module.exports = __webpack_public_path__ + "img/svg/message_duotone.bcbe30ba72890021c428d55799566f75.svg";